/**
 * Contextual keyboard shortcuts (disabled while typing in inputs, except Ctrl/Cmd+Enter deploy in the launcher):
 *  / or Ctrl+K  search            Esc   close / back
 *  ?            shortcuts help    E     end round           N   next round (results)
 *  1 2 3        pick DEV/OG/FIRST on Train                   Shift+P toggle PvP on Train
 *  B            quick-buy current token                      S   sell 100% of current token
 *  L            open launcher     M     mute/unmute           I   toggle instant-trade panel
 */
import { MODES } from '../../shared/config';
import { useSettings } from '../store/settings';
import { openModal, useUi } from '../store/ui';
import { buy, endRound, sell, startRound, useGame } from './game';
import { back, useRoute } from './runtime';
import { toast } from '../store/toast';

export const SHORTCUTS: [string, string][] = [
  ['/ or Ctrl+K', 'Search tokens'], ['Esc', 'Close dialog / go back'], ['?', 'This help'], ['E', 'End the current round'], ['N', 'Next round (from results)'],
  ['1 / 2 / 3', 'Select DEV / OG / FIRST TX (Train view)'], ['Shift+P', 'Toggle PvP (Train view)'], ['B', 'Quick-buy the open token'], ['S', 'Sell 100% of the open token'],
  ['L', 'Open launcher'], ['M', 'Mute / unmute'], ['I', 'Toggle instant-trade panel'], ['Ctrl/⌘+Enter', 'Deploy (launcher; works inside its fields)'], ['Enter', 'Deploy when focus is on a launcher button (configurable)'],
];

const typing = (t: EventTarget | null) => { const e = t as HTMLElement | null; return !!e && (e.tagName === 'INPUT' || e.tagName === 'TEXTAREA' || e.tagName === 'SELECT' || e.isContentEditable); };

export function installKeys() {
  window.addEventListener('keydown', (e) => {
    if (e.defaultPrevented) return;
    const mod = e.ctrlKey || e.metaKey;
    if (mod && e.key.toLowerCase() === 'k') { e.preventDefault(); openModal('search'); return; }
    if (typing(e.target) || e.altKey || (mod && e.key !== 'Enter')) return;
    if (useUi.getState().modal) return;
    const route = useRoute.getState().route; const g = useGame.getState(); const s = useSettings.getState();
    switch (e.key) {
      case '/': e.preventDefault(); openModal('search'); break;
      case '?': openModal('help'); break;
      case 'Escape': if (route.view === 'token') back(); break;
      case 'e': case 'E': if (g.live && g.live.phase !== 'done' && !g.live.mp) endRound('user'); break;
      case 'n': case 'N': if (g.result && !g.live?.mp && (!g.live || g.live.phase === 'done')) startRound(); break;
      case '1': case '2': case '3': if (route.view === 'train' && !g.live) useGame.setState({ mode: MODES[Number(e.key) - 1]! }); break;
      case 'P': if (e.shiftKey && route.view === 'train' && !g.live) useGame.setState({ pvp: !g.pvp }); break;
      case 'b': case 'B': if (route.view === 'token') buy(route.id, s.quickBuySol, e); break;
      case 's': case 'S': if (route.view === 'token') sell(route.id, 1); break;
      case 'l': case 'L': useUi.setState({ feedTab: 'launch' }); s.set({ feedOpen: true }); break;
      case 'm': case 'M': s.set({ sound: !s.sound }); toast(s.sound ? 'Muted' : 'Sound on'); break;
      case 'i': case 'I': s.set({ instant: { ...s.instant, open: !s.instant.open } }); break;
    }
  });
}
